import { Component, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-openbravo-solution',
  templateUrl: './openbravo-solution.component.html',
  styleUrls: ['./openbravo-solution.component.scss']
})
export class OpenbravoSolutionComponent implements OnInit {

  constructor(private meta: Meta) { 
    this.meta.removeTag('name=keywords');
    this.meta.removeTag('name=description');
    this.meta.addTags([ 
      { name: 'description', content: 'Explore our Openbravo solutions at OSIT. We specialize in implementing and customizing Openbravo ERP systems to optimize your business processes in Riyadh, Saudi Arabia. Discover how our Openbravo expertise can streamline your operations and drive business growth.' }, 
      { name: 'keywords', content: 'osit,it,saudi it,software development,website development' } 
  ]);
  }

  ngOnInit() {
  }

}
